import { CommunityCollectionList } from './CommunityCollectionList'

export const CollectionList = () => {
  return <CommunityCollectionList />
}
